import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class LocalChartDeleteService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following LocalCDescGroupObjFactory.saveDeleteChart pattern exactly
  saveDeleteChart(
    baseUrl: string,
    _data: any,
    _accounts: any[],
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action codes like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=2sh6ag`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // Build JSON objects exactly like AngularJS service
    // jsonSettings should be a single object (not an array)
    const jsonSettings = JSON.stringify(_data || {});
    // jsonObj should be an array
    const jsonObj = JSON.stringify(_accounts || []);
    
    // Extend with jsonObj and jsonSettings (AngularJS uses jsonObj and jsonSettings, not clob_data/clob_settings)
    params = _.extend({ jsonObj: jsonObj }, params);
    params = _.extend({ jsonSettings: jsonSettings }, params);
    
    // Core parameters from filterParams, globalService, or rowData
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || rowData?.SCREEN_KEY || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || '';
    
    // Additional required fields
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || rowData?.JCD_TA_KEY || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || rowData?.ACTIVITY_KEY || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || rowData?.SCREEN_TYPE || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || rowData?.IS_LOCKED || 'N';
    
    // Issue-related fields
    params.issue_id = filterParams?.issue_id || rowData?.ISSUE_ID || '';
    params.issue_short_desc = filterParams?.issue_short_desc || rowData?.ISSUE_SHORT_DESC || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || rowData?.ISSUE_ID_FOR_TX_SAVE || '';
    
    // 🚀 CRITICAL: Build checkLockedbj as array with empty object [{}]
    const checkLockedbj: any[] = [{}];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // Dynamic values from filterParams, globalService, or rowData
    params.scenarioCode = filterParams?.scenarioCode || globalService?.scenarioCode || rowData?.SCENARIO_CODE || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || rowData?.IS_ISSUE_KEY_ENABLED || 'N';
    
    // Set process_name exactly like AngularJS
    params.process_name = "DELETE_CHART";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

